import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import DetailService from '@/core/services/detail.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class SectionDetailComponent extends Vue {

  detailService: any = new DetailService();
  sidebarService: any = new SidebarService();
  section_id: any = [];
  logInModal: boolean = false;
  showModal: boolean = false;
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  title: string = "";
  name: string = "";
  createdAt: string = "";
  updatedAt: string = "";

  mounted (){
    const _ = this;
    _.getBySection();
    _.filterDate();
    _.getBySurvey();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  getBySection(){
    const _ = this;
    _.section_id = location.href.split("/");
    _.section_id = _.section_id[5];
    _.isLoading = true;
    _.detailService.getBySection(_.section_id).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.title = data["data"].section.title;
      _.createdAt = data["data"].section.createdAt;
      _.updatedAt = data["data"].section.updatedAt;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getBySurvey(){
    const _ = this;
    let idSurvey: any = location.href.split("/");
    idSurvey = idSurvey[5];
    _.isLoading = true;
    _.detailService.getBySurvey(idSurvey).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].survey.name;
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }
}
